export default "__VITE_ASSET__DnbyucCk__"